import { createContext, useContext } from 'react'
import type { ReactNode } from 'react'

const ManageFieldsActiveContext = createContext(false)

export function ManageFieldsProvider({ children }: { children: ReactNode }) {
  return (
    <ManageFieldsActiveContext.Provider value={true}>
      {children}
    </ManageFieldsActiveContext.Provider>
  )
}

export function useManageFieldsActive(): boolean {
  return useContext(ManageFieldsActiveContext)
}
